module.exports = __webpack_public_path__ + "img/rep-tofalli.eedd2a51.jpg";